module.exports = __webpack_public_path__ + "img/NewsCenterDetails6_pic3.c4f74ca5.png";